import {Task} from './types';

let sequence = 1;
export const MockData: Task[] = [
  {
    id: 64,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156029',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31704 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: 2,
  },
  {
    id: 63,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156028',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31702 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: 2,
  },
  {
    id: 65,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156030',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31706 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: 2,
  },
  {
    id: 222,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156029',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31704 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: 5,
  },
  {
    id: 223,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156030',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31706 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: 5,
  },
  {
    id: 221,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156028',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31702 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: 5,
  },
  {
    id: 183,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156047',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31728 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 184,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156048',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31732 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 185,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '157781',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31734 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 186,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156017',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31754 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 187,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156053',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31756 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 188,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156054',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31758 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 189,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156020',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31760 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 190,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156021',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31763 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 191,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156019',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31764 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 192,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156018',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31766 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 193,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '6099',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32200 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 194,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76621',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32202 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 195,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76620',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32203 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 196,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76618',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32204 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 197,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76607',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32205 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 1,
    shiftId: undefined,
  },
  {
    id: 198,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76619',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32208 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 199,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76625',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32210 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 200,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76626',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32211 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 182,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156046',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31726 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: 4,
  },
  {
    id: 181,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156045',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31724 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: 4,
  },
  {
    id: 2,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156109',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31705 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: 1,
  },
  {
    id: 1,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156060',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31703 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: 1,
  },
  {
    id: 3,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156110',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31707 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 4,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156111',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31709 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 5,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156127',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31711 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 6,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156112',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31713 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 7,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156113',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31715 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 8,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156114',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31717 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 9,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156115',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31718 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 10,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156116',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31719 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 11,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156117',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31721 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 12,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156118',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31722 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 13,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156119',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31723 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 14,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156120',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31725 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 15,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156121',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31727 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 16,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156122',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31729 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 17,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156124',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31731 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 18,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156125',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31733 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 19,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156158',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31753 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 20,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156159',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31755 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 21,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156161',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31759 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 22,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156153',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31761 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 23,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156154',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31762 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 24,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156180',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31765 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 25,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156181',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31767 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 26,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156182',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31769 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-08T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 27,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '6099',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32200 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 28,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76621',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32202 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 29,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76620',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32203 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 30,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76618',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32204 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 31,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76607',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32205 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 1,
    shiftId: undefined,
  },
  {
    id: 32,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76619',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32208 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 33,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76625',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32210 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 34,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76626',
    distrDate: '2021-02-08',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32211 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 66,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156027',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31708 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 67,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156041',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31712 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 68,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156042',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31714 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 69,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156044',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31716 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 70,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156043',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31720 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 71,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156045',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31724 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 72,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156046',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31726 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 73,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156047',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31728 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 74,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156048',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31732 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 75,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '157781',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31734 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 76,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156017',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31754 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 77,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156053',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31756 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 78,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156054',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31758 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 79,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156020',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31760 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 80,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156021',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31763 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 81,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156019',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31764 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 82,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156018',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31766 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-09T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 83,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '6099',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32200 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 84,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76621',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32202 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 85,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76620',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32203 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 86,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76618',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32204 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 87,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76607',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32205 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 1,
    shiftId: undefined,
  },
  {
    id: 88,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76619',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32208 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 89,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76625',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32210 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 90,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76626',
    distrDate: '2021-02-09',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32211 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 112,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156109',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31705 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 113,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156110',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31707 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 114,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156111',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31709 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 115,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156127',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31711 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 116,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156112',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31713 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 117,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156113',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31715 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 118,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156114',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31717 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 119,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156115',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31718 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 120,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156116',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31719 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 121,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156117',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31721 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 122,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156118',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31722 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 123,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156119',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31723 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 124,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156120',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31725 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 125,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156121',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31727 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 126,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156122',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31729 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 111,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156060',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31703 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: 3,
  },
  {
    id: 127,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156124',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31731 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 128,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156125',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31733 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 129,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156158',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31753 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 130,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156159',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31755 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 131,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156161',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31759 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 132,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156153',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31761 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 133,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156154',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31762 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 134,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156180',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31765 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 135,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156181',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31767 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 136,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156182',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31769 (M13)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-10T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 137,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '6099',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32200 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 138,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76621',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32202 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 139,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76620',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32203 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 140,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76618',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32204 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 141,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76607',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32205 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 1,
    shiftId: undefined,
  },
  {
    id: 142,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76619',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32208 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 143,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76625',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32210 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 144,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76626',
    distrDate: '2021-02-10',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32211 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 173,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156028',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31702 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 174,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156029',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31704 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 175,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156030',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31706 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 176,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156027',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31708 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 177,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156041',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31712 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 178,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156042',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31714 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 179,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156044',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31716 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 180,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156043',
    distrDate: '2021-02-11',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31720 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-11T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 224,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156027',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31708 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 225,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156041',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31712 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 226,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156042',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31714 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 227,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156044',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31716 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 228,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156043',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31720 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 229,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156045',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31724 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 230,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156046',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31726 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 231,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156047',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31728 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 232,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156048',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31732 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 233,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '157781',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31734 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:15:00Z',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 234,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156017',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31754 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 235,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156053',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31756 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 236,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156054',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31758 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:30:00Z',
    hubId: 3,
    shiftId: undefined,
  },
  {
    id: 237,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156020',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31760 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 238,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156021',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31763 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 239,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156019',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31764 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 240,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '156018',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '31766 (M2456)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '2021-02-12T01:45:00Z',
    hubId: 4,
    shiftId: undefined,
  },
  {
    id: 241,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '6099',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32200 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 242,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76621',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32202 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 243,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76620',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32203 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 244,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76618',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32204 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 245,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76607',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32205 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 1,
    shiftId: undefined,
  },
  {
    id: 246,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76619',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32208 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 247,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76625',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32210 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
  {
    id: 248,
    taskSequence: 100 * sequence++,
    teamId: 20,
    externalId: '76626',
    distrDate: '2021-02-12',
    distrNo: undefined,
    vehicleTypeId: 1,
    name: '32211 (M1-6)',
    durationMinutesEstimated: 120,
    earliestStartPlanned: '',
    hubId: 2,
    shiftId: undefined,
  },
];
